import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import './styles.css';
import './GlobalFonts.css';
import './styles/responsive-production.css';

// Unregister any existing service workers to prevent cache issues
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => registration.unregister());
  });
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);


